import { css } from 'styled-components';
import { fontWeight } from './fontWeight.js';
import { fontSize } from './fontSize.js';
import { themeGet } from '../../v2/foundation/theme/themeGet/get.js';
import { pxToRem } from '../../v2/foundation/spacing/utils.js';

var baseStyles = css(["color:", ";font-style:normal;"], themeGet('colors.gray.800'));
var formLabel = css(["", ";", ";", ";color:", ";display:inline-block;"], baseStyles, fontSize('small'), fontWeight('semibold'), themeGet('colors.gray.600'));
var bodyContent = css(["", ";", ";", ";"], baseStyles, fontSize('base'), fontWeight('normal'));
var meta = css(["", " ", ";", ";font-style:normal;color:", ";"], baseStyles, fontWeight('normal'), fontSize('tiny'), themeGet('colors.gray.400'));
var link = css(["", " ", ";", ";font-style:normal;color:", ";text-decoration:none;"], baseStyles, fontWeight('normal'), fontSize('small', pxToRem(24)), themeGet('colors.secondary.500'));
var linkHover = css(["", " text-decoration-line:underline;"], link);
var code = css(["", " ", ";", ";"], baseStyles, fontWeight('normal'), fontSize('small', pxToRem(24)));

export { bodyContent, code, formLabel, link, linkHover, meta };
